import React from "react";
import SampleDp from "../../../../../assets/Images/sample-dp.png";
import { ReactComponent as ArrowUpIm } from "../../../../../assets/Icons/Universal/BsBoxArrowUpRight.svg";
import { ReactComponent as ArrowLeftIm } from "../../../../../assets/Icons/Universal/BsBoxArrowRight.svg";
import "../../../../../styles/Pages/Financial/CashInFlow/Fees/FeesCollectedSuccesfully.style.css";

const FeesCollectedSuccesfully = ({ openModel }) => {
  return (
    <div className="FeesCollectedSuccesfullyContainer">
      <div className="titleContainer">
        <div className="frontSection">
          <div className="profile-dp">
            <img src={SampleDp} alt="dp" />
            <div className="infoContainer">
              <div className="name">Taufik Alam</div>
              <div className="gender">Male</div>
            </div>
          </div>
          <span className="seeHistory">
            See History <ArrowUpIm />
          </span>
        </div>
        <div className="id">SM0523019</div>
        <div className="class">Class 5/A</div>
        <div className="date">
          <div className="lastFee">Last fees collect: 23 Oct, 2025</div>
          <div className="period">Last month: August</div>
        </div>
      </div>
      <div className="messageContainer">
        <h1>You have collected successfully</h1>
        <p>Receipt ID: 23456789012</p>
        <h3 onClick={() => openModel(true)}>
          Receipt
          <ArrowLeftIm />
        </h3>
      </div>
    </div>
  );
};

export default FeesCollectedSuccesfully;
